module.exports = __webpack_public_path__ + "static/offer_redeem_fail.e1b3b02c.png";